import type { TFunction } from 'i18next';
import type { GoalType } from '@flugwettrennen/shared';

/** Namen aller Ziele einer Runde, z. B. "Weltreise östlich + Top X Fluggesellschaften". */
export function goalLabel(t: TFunction, types: readonly GoalType[]): string {
  return types.map((g) => t(`goals.${g}`)).join(' + ');
}
